module.exports = __webpack_public_path__ + "img/ludongdong.3329d4de.png";